/** Spec §6 header: "started 2:31 PM" — date-prefixed only when not today. */
export const formatReviewTime = (iso: string): string => {
  const at = new Date(iso);
  const time = at.toLocaleTimeString([], {
    hour: "numeric",
    minute: "2-digit",
  });
  return at.toDateString() === new Date().toDateString()
    ? time
    : `${at.toLocaleDateString([], {
        month: "short",
        day: "numeric",
      })}, ${time}`;
};

/** A Lumen run's stamp — always dated, since runs are compared across days. */
export const formatRunStamp = (iso: string | number): string =>
  new Date(iso).toLocaleString([], {
    month: "short",
    day: "numeric",
    hour: "numeric",
    minute: "2-digit",
  });
